export default __webpack_public_path__ + "assets/d5afcd08a4a563e6b107c2358b65cc28.svg";